import Track from '../../utils/tracking';
import {lazy} from 'react';

const importLogo = () =>
  lazy(() =>
    import(`../../../../imgs/${window.start.siteDataV2.siteCode}/BrandLogo.jsx`)
      .catch((error) => Track.track(`Failed to load ${window.start.siteDataV2.siteCode}'s logo. ${error}`)),
  );

export default importLogo;